<template>
  
  <el-container>
    <el-header class="brand" :class="(workspaceSetup)? 'bottomShade': ''">
      <Header v-on:on-show-how-to="enableHowTo()" :showHowToBtn="isLandingPage && !showHowTo"/>
    </el-header>
    <el-main>
      <HowTo v-if="showHowTo"/>
      <Main  v-else v-on:on-workspace-settingup="onWorkspaceSetup()" />
    </el-main>
    <Footer v-if="isLandingPage || showHowTo" :toggleFooterPos="workspaceSetup" />
  </el-container>

</template>

<script>
import Header from './components/Header.vue'
import Main from './components/Main.vue'
import HowTo from './components/HowToPage.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Main,
    Footer,
    HowTo
  },
  data(){
    return{
      workspaceSetup : false,
      showHowTo: false,
      isLandingPage: true
    }
  },
  methods:{
    onWorkspaceSetup(){
      console.log("workspace setup is set to true");
      this.workspaceSetup = true
      this.isLandingPage = false;
    },
    enableHowTo(){
      console.log("setting show how to true");
      this.showHowTo = true;
      this.onWorkspaceSetup();
    }
  }
}
</script>

<style>
:root {
  --primary-color: #3d85c6; /* #10b981;*/ /* Fresh Emerald */
  --secondary-color: #3b82f6; /* Soft Blue */
  --accent-color: #8b5cf6; /* Soft Purple */
  --bg-color: #f8fafc; /* Very light slate */
  --text-dark: #334155; /* Slate 700 */
  --text-light: #ffffff;
  --border-color: #e2e8f0; /* Slate 200 */
}

#app {
  font-family: 'Outfit', sans-serif;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--text-dark);
  background-color: var(--bg-color);
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-container {
  height: 100%;
}

.el-main {
  padding: 0 !important;
  overflow-y: auto;
}

body {
  height: 100vh;
  margin: 0;
  background-color: var(--bg-color);
  font-weight: 300;
  overflow-y: auto;
}

/* Styles for default el-buttons to be theme-aware */
.el-button.is-circle {
  color: var(--text-dark);
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
}

.el-button.is-circle:hover, .el-button.is-circle:focus {
  color: var(--primary-color);
  border-color: var(--primary-color);
  background-color: var(--bg-color);
}

/* Modern Minimalist Buttons */
.btn {
  background-color: var(--text-light) !important;
  color: var(--text-dark) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 8px !important;
  font-family: 'Outfit', sans-serif !important;
  font-weight: 300 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  transition: all 0.2s ease-in-out !important;
}

.btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  background-color: var(--text-light) !important;
  color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.btn:active {
  transform: translateY(0) !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.btn-highlight, .btn-dark:hover {
  background-color: var(--primary-color) !important;
  color: var(--text-light) !important;
  border-color: var(--primary-color) !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.btn-highlight:hover {
  background-color:var(--primary-color) !important; /* Slightly darker emerald */
  color: var(--text-light) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  border-color: var(--primary-color) !important;
}

.brand-dark {
  background-color: var(--text-dark) !important;
}

.brand-light {
  background-color: var(--secondary-color) !important;
}

.btntxt {
  color: var(--text-dark) !important;
  font-weight: 300 !important;
  font-family: 'Outfit', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.2s ease;
}

.btntxt:hover {
  color: var(--primary-color) !important;
}

.txt {
  color: var(--text-dark);
}

.bottomShade {
  border-bottom: 1px solid var(--border-color);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.mainHeading {
  font-size: 3rem;
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--text-dark);
}

.heading {
  font-size: 2rem;
  font-weight: 300;
  letter-spacing: 0;
}

.subheading {
  font-size: 1.25rem;
  font-weight: 200;
  opacity: 0.8;
}

/* Modern Minimalist cards/elevated areas */
.elevatedStage {
  border-radius: 12px;
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background-color: var(--text-light);
  color: var(--text-dark);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.elevatedStage:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.brand {
  background: var(--bg-color);
  border-bottom: 1px solid var(--border-color);
}

.bg {
  background-color: var(--bg-color);
}

.brand2 {
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

/* Element Plus Overrides for Modern Minimalist */
.el-upload-dragger {
  border: 1px dashed var(--border-color) !important;
  border-radius: 8px !important;
  background-color: var(--bg-color) !important;
  transition: all 0.3s ease !important;
}

.el-upload-dragger:hover {
  border-color: var(--primary-color) !important;
  background-color: #ecfdf5 !important;
}

/* Dark Theme overrides (adapted for modern minimalist) */
html.dark-theme body {
  --bg-color: #0f172a;
  --text-dark: #f8fafc;
  --text-light: #1e293b;
  --border-color: #334155;
  --primary-color: #9fc5e8; /*#34d399;*/ /* Lighter emerald for dark mode */
}

html.dark-theme .elevatedStage {
  background-color: #1e293b;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
}

html.dark-theme .brand {
  background: var(--bg-color);
}

html.dark-theme .brand-dark {
  background-color: var(--text-light) !important;
}

html.dark-theme .el-upload-dragger {
  background-color: #1e293b !important;
}

html.dark-theme .el-upload-dragger:hover {
  background-color: #064e3b !important;
}

/* Dark Theme styles for El-Dialog (Settings Modal) */
html.dark-theme .el-dialog {
  background-color: var(--text-light) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.5), 0 4px 6px -2px rgba(0,0,0,0.2) !important;
}

html.dark-theme .el-dialog__title {
  color: var(--text-dark) !important;
}

html.dark-theme .el-dialog__headerbtn .el-dialog__close {
  color: var(--text-dark) !important;
}

html.dark-theme .el-dialog__body {
  color: var(--text-dark) !important;
}

html.dark-theme .el-dialog__footer {
  border-top: 1px solid var(--border-color) !important;
}

/* Dark Theme styles for El-Button-Group */
html.dark-theme .el-button-group {
  border: 1px solid var(--border-color) !important;
  border-radius: 8px !important;
}

html.dark-theme .el-button-group .el-button {
  background-color: var(--text-light) !important;
  color: var(--text-dark) !important;
  border: none !important;
}

html.dark-theme .el-button-group .el-button:hover,
html.dark-theme .el-button-group .el-button:focus {
  color: var(--primary-color) !important;
  background-color: var(--bg-color) !important;
}

html.dark-theme .el-button-group .el-button--primary {
  background-color: var(--primary-color) !important;
  color: var(--text-light) !important;
}

html.dark-theme .el-button-group .el-button--primary:hover,
html.dark-theme .el-button-group .el-button--primary:focus {
  background-color: var(--primary-color) !important; /* Slightly darker emerald */
  color: var(--text-light) !important;
}

/* Dark Theme styles for El-Input and El-Input-Number */
html.dark-theme .el-input__inner {
  background-color: var(--text-light) !important;
  color: var(--text-dark) !important;
  border-color: var(--border-color) !important;
}

html.dark-theme .el-input-number__increase,
html.dark-theme .el-input-number__decrease {
  background-color: var(--bg-color) !important;
  color: var(--text-dark) !important;
  border-color: var(--border-color) !important;
}

html.dark-theme .el-input-number__increase:hover,
html.dark-theme .el-input-number__decrease:hover {
  color: var(--primary-color) !important;
}

/* Dark Theme styles for standalone El-Buttons */
html.dark-theme .el-button:not(.el-button--primary):not(.el-button--text):not(.btn) {
  background-color: var(--text-light) !important;
  color: var(--text-dark) !important;
  border-color: var(--border-color) !important;
}

html.dark-theme .el-button:not(.el-button--primary):not(.el-button--text):not(.btn):hover {
  color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

/* Dark Theme styles for El-Color-Picker */
html.dark-theme .el-color-picker__trigger {
  border-color: var(--border-color) !important;
}
</style>
